import {
  Id,
  PolicyAction,
  PolicyExpenseLimits,
  PolicyOperator
} from 'src/types'

export const initialValues = {} as PolicyExpenseLimits

export function getInitialValuesPolicyExpenseLimits({
  policy_id = ''
}: {
  policy_id: Id
}): PolicyExpenseLimits {
  return {
    action: PolicyAction.ALERT,
    active: true,
    currency_id: '',
    daily_limit: 0,
    limit: 0,
    operator: PolicyOperator.LESS_THAN,
    policy_expense_limit_id: new Date().toJSON(),
    policy_id: policy_id === '' ? null : +policy_id || null,
    reason_id: '',
    reference_id: '',
    service_id: '',
    value: 0
  }
}
